import { render, staticRenderFns } from "./formbuilderFilters.vue?vue&type=template&id=28727c69"
import script from "./formbuilderFilters.vue?vue&type=script&lang=js"
export * from "./formbuilderFilters.vue?vue&type=script&lang=js"
import style0 from "./formbuilderFilters.vue?vue&type=style&index=0&id=28727c69&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports